import * as React from 'react';
import { Link } from 'react-router-dom';
import './MenuItem.scss';

interface IMenuItemProps {
	icon: React.ReactElement ;
	text: string;
	route: string;
	active?: boolean;
}

const MenuItem = (props: IMenuItemProps) => (<div className={`menu-item ${props.active ? 'menu-item-active' : ''}`}>
	<div className="menu-item-border" />
	<Link to={props.route} className="menu-item-content">

		<div className="menu-item-content-icon">
			{props.icon as any}
		</div>
		<div className="menu-item-content-title">{props.text}</div>
	</Link>
</div>);

export default MenuItem;
